import { Link } from 'react-router-dom';
import './ProgettoNav.css';

interface ProgettoNavProps {
    prevPath?: string;
    nextPath?: string;
}

function ProgettoNav({ prevPath, nextPath }: ProgettoNavProps) {
    return (
        <div className='progetto-nav'>
            {prevPath ? (
                <Link to={prevPath} className='progetto-nav-link progetto-nav-prev'>
                    <span className='progetto-nav-arrow' aria-hidden='true'>&#8592;</span>
                    <span>Progetto precedente</span>
                </Link>
            ) : (
                <span className='progetto-nav-link progetto-nav-prev progetto-nav-disabled' aria-disabled='true'>
                    <span className='progetto-nav-arrow' aria-hidden='true'>&#8592;</span>
                    <span>Progetto precedente</span>
                </span>
            )}
            {nextPath ? (
                <Link to={nextPath} className='progetto-nav-link progetto-nav-next'>
                    <span>Prossimo progetto</span>
                    <span className='progetto-nav-arrow' aria-hidden='true'>&#8594;</span>
                </Link>
            ) : (
                <span className='progetto-nav-link progetto-nav-next progetto-nav-disabled' aria-disabled='true'>
                    <span>Prossimo progetto</span>
                    <span className='progetto-nav-arrow' aria-hidden='true'>&#8594;</span>
                </span>
            )}
        </div>
    );
}

export default ProgettoNav;
